import React, { useState } from 'react';
import SingleDateWithoutArrow from '../../components/Date-range-picker/SingleDateWithoutArrow';

import {
    TextField,
    Button,
    IconButton,
    Typography,
    Box,
    Modal,
    InputLabel,
    MenuItem,
    Select,
    FormControl,
    Grid,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import MultiClientSelect from '../../components/DemoTabs/MultiClientSelect';
import CheckBoxSec from '../../pages/Settings/General-Settings/CheckBoxSec';
import SingleSelectDroupdown from '../../components/Projects/project-components/SingleSelectDroupdown';

const roles = [
    { label: 'Fixed schedule', description: 'Set the time and day(s) of the week to start timer' },
    { label: 'Shifts', description: 'Any shift that the user has been assigned' },
];

const modalMoveActivities = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '600px',
    width: '90%',
    margin: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: '2px',
    // border: '2px solid #0B57D0'
    border: '2px solid transparent',
    backgroundImage: 'linear-gradient(white, white), linear-gradient(136deg, rgba(0, 170, 231, 1), rgba(89, 50, 234, 1))',
    backgroundOrigin: 'border-box',
    backgroundClip: 'content-box, border-box',
    borderRadius: '12px',
};

const AutomaticTimer = ({ open, onClose }) => {
    const [selectedProject, setSelectedProject] = useState(null);
    const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    // start Members 
    const [selectedUsers, setSelectedUsers] = useState([]);
    const users = [
        { name: 'John Doe', image: 'https://randomuser.me/api/portraits/men/1.jpg' },
        { name: 'Alice Smith', image: null },
        { name: 'Mike Johnson', image: 'https://randomuser.me/api/portraits/men/2.jpg' },
        { name: 'Mike2 Johnson', image: 'https://randomuser.me/api/portraits/men/3.jpg' },
        { name: 'Mike3 Johnson', image: 'https://randomuser.me/api/portraits/men/4.jpg' },
        { name: 'Mike4 Johnson', image: 'https://randomuser.me/api/portraits/men/5.jpg' },
    ];
    const [setOpen] = React.useState(false);
    const [activeDays, setActiveDays] = useState(['Mon', 'Tue', 'Wed', 'Fri', 'Sat']);
    const toggleDay = (day) => {
        setActiveDays((prev) =>
            prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]
        );
    };
    const [role, setRole] = useState('');
    const handleChangeUser = (event) => {
        setRole(event.target.value);
    };
    return (
        <Modal open={open} onClose={onClose} fullWidth maxWidth="sm">
            <Box sx={{
                ...modalMoveActivities,
                display: 'flex',
                flexDirection: 'column',
                maxHeight: '90vh',
                overflow: 'hidden',
            }}>
                {/* Header */}
                <Box display="flex" justifyContent="space-between" alignItems="center"
                    sx={{ p: '20px', borderBottom: '1px solid #e0e0e0', position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff', borderRadius: '12px 12px 0 0' }}>
                    <Typography variant="h6" fontSize={'17px'} fontWeight={'700'} sx={{ lineHeight: '1', fontFamily: 'Manrope' }}>Automatic Timer Policy</Typography>
                    <IconButton onClick={onClose} className='p-0'>
                        <CloseIcon sx={{ fontSize: '20px', color: '#000' }} />
                    </IconButton>
                </Box>
                {/* End Header */}
                {/* start Body sec  */}
                <Box sx={{ flex: 1, overflowY: 'auto', px: '22px', py: '26px' }} dividers>
                    <Box display="flex" alignItems="center" sx={{ gap: '12px', border: '1px solid #0076FE', backgroundColor: '#0076FE0A', borderRadius: '8px', p: '12px 16px', height: '56px', margin: '0 auto 24px' }}>
                        <img src='./assets/images/app-activity/icon.png' className='img-fluid' alt='allowed apps icon' />
                        <Typography sx={{ fontSize: '14px', fontWeight: '400', color: '#1A1F36', fontFamily: 'Manrope' }}>
                            This policy only applies to the desktop app. You can restrict which apps your members may use in <span style={{ color: '#0076FE', fontWeight: '500' }}>Allowed apps setting</span>
                        </Typography>
                    </Box>
                    <Box sx={{ m: '0 auto 16px' }}>
                        <Typography color='#1A1F36' fontWeight={600} sx={{ fontSize: '14px', fontWeight: '600', margin: '0 auto 4px', fontFamily: 'Manrope' }}>Policy Name</Typography>
                        <TextField fullWidth placeholder="Enter a name for the policy" variant="outlined" margin="normal"
                            sx={{
                                marginTop: '0', fontFamily: 'Manrope', '& .MuiOutlinedInput-root': {
                                    height: '40px', fontSize: '14px', color: '#64748B', fontFamily: 'Manrope',
                                    '& fieldset': { borderColor: '#D0D5DD', fontFamily: 'Manrope' },
                                }, '& .MuiInputBase-input': { padding: '10px 18px', fontFamily: 'Manrope' },
                            }} />
                    </Box>
                    {/* start Members sec  */}
                    <Box sx={{ pb: 0, }}>
                        <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block', fontFamily: 'Manrope' }}>Teams / Members</InputLabel>
                        <MultiClientSelect label="Select Team Members" options={users} selectedValues={selectedUsers} onChange={setSelectedUsers} />
                    </Box>
                    {/* End Members sec  */}
                    <Box display="flex" alignItems="center" sx={{ gap: '12px', margin: '8px auto 24px' }}>
                        <CheckBoxSec projects={[{ name: true }]} />
                        <Box>
                            <Typography sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', fontFamily: 'Manrope' }}>Set as the default auto - add policy for your organization</Typography>
                            <Typography sx={{ fontSize: '12px', fontWeight: '400', color: '#64748B', fontFamily: 'Manrope' }}>New members will be automatically added to this policy</Typography>
                        </Box>
                    </Box>
                    <Box sx={{ pb: 2, }}>
                        <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block', fontFamily: 'Manrope' }}>Timer Start / Stop Rules</InputLabel>
                        <FormControl fullWidth variant="outlined" size="small">
                            <Select
                                value={role}
                                onChange={handleChangeUser}
                                displayEmpty
                                renderValue={(selected) =>
                                    selected ? (
                                        selected
                                    ) : (
                                        <Typography color="text.secondary" sx={{ fontSize: '14px', color: '#64748B', fontWeight: '400', fontFamily: 'Manrope' }}>
                                            Fixed schedule
                                        </Typography>
                                    )
                                }
                                sx={{
                                    backgroundColor: 'white',
                                    borderRadius: 1,
                                    fontFamily: 'Manrope',
                                    fontSize: '14px',
                                    color: '#64748B'
                                }}
                            >
                                {roles.map((option) => (
                                    <MenuItem key={option.label} value={option.label}>
                                        <Box>
                                            <Typography variant="body1" sx={{ fontSize: '14px', color: '#1A1F36', fontWeight: '500', fontFamily: 'Manrope' }}>{option.label}</Typography>
                                            <Typography variant="body2" sx={{ fontSize: '14px', color: '#595959', fontWeight: '400', fontFamily: 'Manrope' }} color="text.secondary">
                                                {option.description}
                                            </Typography>
                                        </Box>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                    <Box display="flex" alignItems="center" sx={{ gap: '12px', margin: '8px auto 24px' }}>
                        <CheckBoxSec projects={[{ name: true }]} />
                        <Box>
                            <Typography sx={{ fontSize: '14px', fontWeight: '400', color: '#64748B', fontFamily: 'Manrope' }}>Don’t start timer until first activity</Typography>
                        </Box>
                    </Box>
                    <Box sx={{ m: '20px auto 24px' }}>
                        <Typography sx={{ fontSize: '16px', fontWeight: '600', color: '#1E1E1E', fontFamily: 'Manrope' }}>Days of the week</Typography>
                        <Box display="flex" flexWrap="wrap" sx={{ gap: '4px', m: '4px auto 0' }}>
                            {days.map((day) => {
                                const isActive = activeDays.includes(day);
                                return (
                                    <Button key={day} onClick={() => toggleDay(day)} variant="contained"
                                        sx={{
                                            borderRadius: '30px', backgroundColor: isActive ? '#0076FE' : '#F3F4F6', color: isActive ? '#FFFFFF' : '#606060', textTransform: 'none', px: '16px', py: '6', display: 'flex',
                                            alignItems: 'center', gap: 1, fontWeight: '400', fontFamily: 'Manrope', boxShadow: 'unset', height: '30px', '&:hover': { backgroundColor: isActive ? '#006AE0' : '#D1D5DB', },
                                        }}>
                                        {day}

                                    </Button>
                                );
                            })}
                        </Box>
                    </Box>
                    <Grid container columnSpacing={2} sx={{ m: '0 auto 24px', }}>
                        <Grid item size={{ xs: 12, md: 6 }}>
                            <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block', fontFamily: 'Manrope' }}>Start</InputLabel>
                            <Box>
                                <SingleDateWithoutArrow sx={{ width: '100%' }} />
                            </Box>
                        </Grid>
                        {/* Job Type */}
                        <Grid item size={{ xs: 12, md: 6 }}>
                            <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block', fontFamily: 'Manrope' }}>Stop</InputLabel>
                            <SingleDateWithoutArrow sx={{ width: '100%' }} />
                        </Grid>
                    </Grid>
                    {/* start Projects sec  */}
                    <Box sx={{ pb: 0, }}>
                        <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block', fontFamily: 'Manrope' }}>Starting Project</InputLabel>
                        <SingleSelectDroupdown
                            selectedProject={selectedProject}
                            setSelectedProject={setSelectedProject}
                        />
                    </Box>
                    {/* End Projects sec  */}
                </Box>
                {/* End Body sec  */}

                {/* start Footer sec  */}
                <Box sx={{ p: '20px 30px', borderTop: '1px solid #e0e0e0', position: 'sticky', bottom: 0, backgroundColor: '#F2F6F9', display: 'flex', justifyContent: 'space-between', gap: 2, borderRadius: '0 0 12px 12px' }}>
                    <Button onClick={onClose} variant="outlined" className='bg-white text-capitalize' color="#595959" sx={{ p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #D9D9D9', fontFamily: 'Manrope' }}>
                        Cancel
                    </Button>
                    <Button variant="contained" color="primary" className='text-capitalize' sx={{ backgroundColor: '#0B57D0', p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #0B57D0', fontFamily: 'Manrope' }}>
                        Save
                    </Button>
                </Box>
                {/* End Footer sec  */}
            </Box>
        </Modal>
    );
};

export default AutomaticTimer;
